// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1dFWX","imageUploader":"EGiftCard_imageUploader__2Cpvq"};